import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Link, useNavigate } from 'react-router-dom';
import { getPassCode, getCurrentUser, checkApiError } from '../../utils';
import Agenda from "./event_agenda";
import ContactInfo from "./contactinfo";
import './../../css/manageuserevent.css';
import { toast } from "react-toastify";

const Events = ({ showLoading }) => {
    const navigate = useNavigate();
    const today = new Date().toISOString();
    const location = useLocation();
    const eventRef = useRef(null);
    const agendaRef = useRef(null);
    const [isEventUpdated, setIsEventUpdated] = useState(false);
    const [isDateUpdated, setIsDateUpdated] = useState(false);
    const isAddEvent = location.state.mode === 'add' ? true : false;
    const [event, setEvent] = useState({
        eventId: null,
        eventStartDate: today, // Default to today for add events
        eventEndDate: today,    // Default to today for add events
        eventTimeZone: "Pacific Standard Time",
        eventType: 'Virtual Event',
        eventTitle: '',
        welcomeText: '',
        eventStatus: "Upcoming",//Upcoming / Completed / Ongoing
        IsActive: 1,
        lastModifiedById: getCurrentUser().userId
    });
    useEffect(() => {
        if(getPassCode() === ""){
            navigate("/login");
        }
        // Update event state if location.state.event changes (e.g., for edit mode)
        if (!isAddEvent && location.state?.event) {  // Only for edits, not add
            setEvent({ ...location.state.event });
        }
    }, [location.state?.event, isAddEvent, navigate]);

    const [currentForm, setCurrentForm] = useState('event');
    const [showModal, setShowModal] = useState(false);
    const [queCharCount, setQueCharCount] = useState(0);    
    
    const [inputErrors, setInputErrors] = useState({});

    const isValidEndDate = (_sDate, _eDate)=>{
        if(_sDate === '' || _eDate === ''){ return; }
        const esd = new Date(_sDate).toISOString().split("T", 1)[0];
        const eed = new Date(_eDate).toISOString().split("T", 1)[0];

        if(esd===eed){
            return true;
        }else{
            return esd < eed;
        }
    }

    const validateInput = () => {
        const errors = {};
        if (!event.eventTitle) {
            errors.eventTitle = "Event title is required.";
        }
        if (!event.welcomeText) {
            errors.welcomeText = "Event Welcome text is required.";
        }
        if (event.eventStartDate === '') {
            errors.eventStartDate = "Event start date is required.";
        }
        if (event.eventEndDate === '') {
            errors.eventEndDate = "Event end date is required.";
        }
        if (!isValidEndDate(event.eventStartDate, event.eventEndDate)) {
            errors.eventEndDate = "End date must be greater than or equal to start date.";
        }
        
        setInputErrors(errors);
        return Object.keys(errors).length === 0; // Return true if no errors
    };

    const checkFieldValidate = (name, value) => {
        let newErrors = { ...inputErrors };
        let flag = false;
        switch (name) {
          case 'eventTitle':
          case 'welcomeText':
            // Validate: Special characters not allowed except (.,'-&)
            flag = (!/^[a-zA-Z0-9\s-,.'&/()!:]*$/.test(value));      
            break;
          default:
            break;
        }
    
        if (flag) {
          newErrors[name] = "Special characters not allowed except (. , ' - & / ! :)";
        } else {
          delete newErrors[name];
        }
    
        setInputErrors(newErrors);
      }

    const handleClose = () => {
        setShowModal(false);
        navigate('/event-management');
    };
    const handleMapAttendees = () => {
        setShowModal(false);
        navigate('/event-management/attendee-mapping', { state: { event } });
    };
    // handle input values to store in event object.
    const handleInputChange = (e) => {
        const { name, value } = e.target;   
        checkFieldValidate(name, value);
        if (name === 'welcomeText')
            setQueCharCount(value.length)
        setEvent({ ...event, [name]: value });
        setIsEventUpdated(true);
    };
    const handleEventStartDateChange = (newStartDate) => {
        if(newStartDate === ''){
            setEvent(prevEvent => ({
                ...prevEvent,
                eventStartDate: newStartDate
            }));
        }else{
            setEvent(prevEvent => ({
                ...prevEvent,
                eventStartDate: newStartDate + "T09:00:00.291Z"
            }));
        setIsDateUpdated(true);
            setIsEventUpdated(true);
        }
    };

    const handleEventEndDateChange = (newEndDate) => {
        if(newEndDate === ''){
            setEvent(prevEvent => ({
                ...prevEvent,
                eventEndDate: newEndDate
            }));
        }else{
            setEvent(prevEvent => ({
                ...prevEvent,
                eventEndDate: newEndDate + "T09:00:00.291Z"
            }));
        setIsDateUpdated(true)
            setIsEventUpdated(true);
        }
    }
    const timeZones = [
        { name: "Pacific Time (PT)", value: "Pacific Standard Time" },
        { name: "Eastern Time (ET)", value: "Eastern Standard Time" },
        //{ name: "Indian Time (IT)", value: "India Standard Time" },
    ];
    const handleTimeZoneChange = (newTimeZone) => {
        setEvent(prevEvent => ({
            ...prevEvent,
            eventTimeZone: newTimeZone
        }));
        setIsEventUpdated(true);
    };
    const backCurrentForm = () => {
        switch (currentForm) {
            case 'contactinfo': setCurrentForm('agenda'); break;
            case 'agenda': setCurrentForm('event'); break;
            default: setCurrentForm('event');
        }
    }

    const sendEvents = async () => {
        if(isAddEvent){
            event.createdById =  getCurrentUser().userId;
        }
        if (isEventUpdated) {
            event.lastModifiedById =  getCurrentUser().userId;
            try {
                showLoading(true);
                const response = await fetch(`${process.env.REACT_APP_API_URL}/Event/addupdateevents`, {
                    method: 'POST',
                    headers: {
                        "Authorization": `Bearer ${getPassCode()}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(event)
                });

                if(checkApiError(response.status)){ navigate("/login"); return; }

                if (response.ok) {
                    const data = await response.json();
                    event.eventId = data.eventDetails.eventId;
                } else {
                    console.error('Error Events list not received:', response.status);
                }
            } catch (error) {
                console.log(error);
            } finally {
                showLoading(false);
            }
        }
    };

    const valideEventPanel = ()=>{
        if(validateInput()){
            sendEvents(); 
            setCurrentForm('agenda');
        }
    }

    const saveAndNext = () => {
        switch (currentForm) {
            case 'event': valideEventPanel(); break;
            case 'agenda':
                agendaRef.current.sendToDB((bool) => {
                    // This will run after sendToDB completes
                    if(bool){
                        setCurrentForm('contactinfo');
                    }
                });
                // setCurrentForm('contactinfo');
                 break;
            default: setCurrentForm('contactinfo');
        }
    }

    const submitEvent = async () => {
        eventRef.current.validateContactInfo();
        let getContactInfo = eventRef.current.getContacts();
        //console.log(getContactInfo, "getContactInfo");
        let isError = false;
        const payload = [];
        getContactInfo.coordinators &&
        getContactInfo.coordinators.map((item) => {
            //if (!item.contactNumber) isError = true;
                return payload.push({
                coordinatorId: item.coordinatorId || "",
                eventId: event.eventId,
                organizingCommitteeEmail: getContactInfo.committeEmail,
                userId: item.userId,
                coordinatorContactNumber: item.contactNumber,
                createdById: item.createdById,
                dateCreated: item.dateCreated,
                lastModifiedById: item.lastModifiedById,
                lastModifiedDate: item.lastModifiedDate,
            });
        });
        if (payload.length > 0 && !isError) {
            try {
                showLoading(true);
                const response = await fetch(
                `${process.env.REACT_APP_API_URL}/EventCoordinator/insertupdateEventCoordinator`,
                {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json",
                    Accept: "*/*",
                    Authorization: `Bearer ${getPassCode()}`, // Assuming you need to pass the token
                    },
                    body: JSON.stringify({ eventCoordinators: payload }),
                }
                );
                if (response.status === 200) {
                    setShowModal(true);
                } else {
                    console.error("Error, Save Event Failed.", response.status);
                    toast.error("Save Event Failed");
                }
            } catch (error) {
                console.error("Error, Save Event Failed.", error);
            } finally {
                showLoading(false);
            }
        }
    };

    return (
        <div className="manage-user-events w3-container mt-4 mb-4">
            <p className="roboto-bold mb-2 color-black t-h">{isAddEvent ? 'Add Events' : 'Edit Event'}</p>

            <nav aria-label="breadcrumb">
                <ol className="breadcrumb fs-0-8">
                    <li className="breadcrumb-item">
                        <Link className='color-purple' to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                        <Link className='color-purple' to="/event-management">Manage Events</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {isAddEvent ? 'Add Events' : 'Edit Event'}
                    </li>
                </ol>
            </nav>
            <div className="card mt-4 mb-4">
                <div className="card-body p-4">
                    <form>
                        {/* form for show event details panel */}
                        {currentForm === 'event' &&
                            <>
                                { event.eventId && <div className="row mb-4">
                                    <p className="m-0 text-danger">
                                        <span className="me-2 position-relative">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="position-absolute" viewBox="0 0 16 16">
                                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
                                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
                                            </svg>
                                        </span>
                                        <span className="ms-3 small">
                                        Changing the date will erase all current agenda details.
                                        </span>
                                    </p>
                                </div> }
                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="eventType" className="form-label">
                                            <span className="text-danger">*</span> Select Event Type:
                                        </label>
                                        <select disabled id="eventType" name="eventType" className="form-select pe-none" onChange={(e) => { handleInputChange(e) }} value={event.eventType}>
                                            <option value="Virtual">Virtual Event</option>
                                            <option value="Live">Live Event</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="eventTitle" className="form-label">
                                            <span className="text-danger">*</span> Event title:
                                        </label>
                                        <input type="text" name="eventTitle" id="eventTitle" value={event.eventTitle} className={`form-control ${inputErrors.eventTitle && 'border-danger'}`} onChange={handleInputChange} />
                                        {inputErrors.eventTitle && <div className="text-danger small mt-1">{inputErrors.eventTitle}</div>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 col-12 mb-4">
                                        <label htmlFor="eventStartDate" className="form-label"><span className="text-danger">*</span> Event Start Date:</label>
                                        <input type="date" className={`form-control ${inputErrors.eventStartDate && 'border-danger'}`} id="eventStartDate" name="eventStartDate" value={event.eventStartDate.split('T')[0]} onChange={(e) => handleEventStartDateChange(e.target.value)} min={today.split("T")[0]} />
                                        {inputErrors.eventStartDate && <div className="text-danger small mt-1">{inputErrors.eventStartDate}</div>}
                                    </div>
                                    <div className="col-md-4 col-12 mb-4">
                                        <label htmlFor="eventEndDate" className="form-label"><span className="text-danger">*</span> Event End Date:</label>
                                        <input type="date" className={`form-control ${inputErrors.eventEndDate && 'border-danger'}`} id="eventEndDate" name="eventEndDate" value={event.eventEndDate.split('T')[0]} onChange={(e) => handleEventEndDateChange(e.target.value)} min={event.eventStartDate.split('T')[0]} />
                                        {inputErrors.eventEndDate && <div className="text-danger small mt-1">{inputErrors.eventEndDate}</div>}
                                    </div>
                                    <div className="col-md-4 col-12 mb-4">
                                        <label htmlFor="timeZone" className="form-label">Select Time Zone:</label>
                                        <select className="form-select" id="eventTimeZone" name="eventTimeZone" value={event.eventTimeZone} onChange={(e) => handleTimeZoneChange(e.target.value)} >
                                            {timeZones.map(tz => (
                                                <option key={tz.value} value={tz.value}>
                                                    {tz.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>                                    
                                </div>
                                <div className="row">
                                    <div className="col-12 mb-4">
                                        <label htmlFor="welcomeText" className="form-label">
                                            <span className="text-danger">*</span> Welcome text:
                                        </label>
                                        <div className="position-relative">
                                            <textarea name="welcomeText" id="welcomeText" maxLength={150} rows={6} className={`form-control ${inputErrors.welcomeText && 'border-danger'}`} value={event.welcomeText} onChange={handleInputChange} />
                                            <div className='cShow-char-len'>{queCharCount}/150</div>
                                        </div>
                                        {inputErrors.welcomeText && <div className="text-danger small mt-1">{inputErrors.welcomeText}</div>}
                                    </div>
                                </div>
                            </>
                        }

                        {/* form for show agenda details panel */}
                        {currentForm === 'agenda' &&
                            <Agenda event={event} isAddEvent={isAddEvent} setIsDateUpdated={setIsDateUpdated} isDateUpdated={isDateUpdated} showLoading={showLoading}  ref={agendaRef}></Agenda>
                        }

                        {/* form for show contact info details panel */}
                        {currentForm === 'contactinfo' &&
                            <ContactInfo showLoading={showLoading} eventId={event.eventId} ref={eventRef}></ContactInfo>
                        }

                        <div className="d-flex justify-content-start mt-4">
                            {currentForm !== 'event' &&
                                <button type="button" className="btn btn-purple me-2" onClick={backCurrentForm}> Back </button>
                            }
                            {currentForm !== 'contactinfo' ? (
                                <button type="button" className="btn btn-purple me-2" onClick={saveAndNext}> Save & Next </button>
                            ) : (
                                <button type="button" className="btn btn-purple me-2" onClick={() => { submitEvent() }}> Save Event </button>
                            )}
                            {currentForm === 'event' &&
                                <button type="button" className="btn btn-secondary" onClick={() => {navigate('/event-management')}}>Cancel</button>
                            }
                        </div>
                    </form>
                </div>
            </div>

            {showModal && (
                <div className="map-attendee-modal modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }} >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body text-center p-5">
                                <button type="button" className="btn-close-modal btn btn-close" aria-label="Close" onClick={handleClose} ></button>
                                <img src='/event-created.png' alt="Success" className="mb-4" />
                                {isAddEvent ? (
                                    <h4 className="mb-4 color-purple"> Event has been created successfully. </h4>
                                ) : (
                                    <h4 className="mb-4 color-purple"> Event has been modified successfully. </h4>
                                )}
                                <p className="mb-4 fs-1-1 fw-300"> By clicking on below map attendees button, you can map attendees for the newly created event "<span className="fw-bold">{event?.eventTitle}</span>". </p>
                                <button className="btn-map-attendee btn btn-purple ps-4 pe-4 pt-2 pb-2" onClick={handleMapAttendees} > Add Attendees </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Events;
